export const locale = {
  lang: 'en',
  data: {
    TITLE: 'Edit mandatory documents',
    OTHER_DOC: {
      MANDATORY_DOC: 'Mandatory documents',
      LOAD_DOC: 'Upload the following documents',
      MORE_DOC: 'Other mandatory documents',
      OTHER_DOC: 'Other documents',
      INFO:
        'Completa la pratica allegando altri documenti che ritieni utili al fine di velocizzare l\'ammissione della fattura all\'asta\n' +
        '(es. contratto di fornitura, eventuale bolla di accompagnamento).',
      DELIVERY_NOTE: 'Delivery note',
      DELIVERY_NOTE_CARRIER: 'Delivery note carrier signed by carrier',
      CUSTOMER_ORDER: 'Customer order',
      SUPPLY_CONTRACT: 'Supply contract',
      SDI_DELIVERY_RECEIPT: 'SDI delivery receipt',
      XML_INVOICE: 'Electronic invoice in xml format',
      XML_INVOICE_DOC: 'Electronic invoice in xml format',
      CLIENT_LEDGER: 'Client ledger',
      OTHER: 'Other',
      CUSTOMER_ORDER_CONFIRMATION: 'Customer order confirmation',
      WORK_PROGRESS: 'Work progress',
      RELEASE_GUARANTEE_LETTER: 'Release guarantee letter',
      CUSTOMER_EMAIL_EXCHANGE: 'Customer email exchange',
      PAYMENT_SLIP: 'Payment slip',
      DEBTOR_PLAFOND: 'Debtor plafond',
      CREDIT_INSURANCE: 'Credit insurance',
      CREDIT_MANAGEMENT: 'Credit management',
      CENTRAL_CREDIT_REGISTER: 'Central credit register',
      INVOICE_CONFIRMATION: 'Invoice confirmation',
      REGISTERED_MAIL: 'Registered mail',
      ADD: 'Add',
      DELETE: 'Do you want to delete this attachment?',
      NO: 'No',
      YES: 'Yes',
      LABEL: {
        DELIVERY_NOTE: '# Delivery',
        CUSTOMER_ORDER: '# Order',
        SUPPLY_CONTRACT: '# Contract',
      },
    },
    ACTION: {
      CLOSE: 'Close',
    },
    ERROR: {
      REQUIRED: 'Field required',
      INVALID: 'Value invalid',
      EMAIL: 'Please enter a valid email address',
      TAX_CODE: {
        INVALID: 'Tax code invalid',
        FORMAT: 'Wrong format',
      },
      PHONE: 'Please enter a valid phone number',
      DATE: 'Please enter a valid date',
      MINIMUM_BID_1: 'Value must be between',
      MINIMUM_BID_2: 'and',
      SELL_NOW: 'Value must be between minimum bid and invoice amount',
      ATTACHMENT_UPLOAD: 'Error editing attachment',
    },
  },
};
